/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_ResizeInputs */



/**
* | output |
* | --- |
* | "Resize the chat panel" |
*
* @param {Chat_ResizeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_resize = /** @type {((inputs?: Chat_ResizeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_ResizeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Breedte van het chatpaneel aanpassen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajuster la largeur du panneau de chat")
	return /** @type {LocalizedString} */ ("Resize the chat panel")
});